<span class="text-muted">
  <small>
    Saved {{ changeDate | date: 'd-MMM-yyyy h:mm a' }} by
    {{ changedBy | username }}
  </small>
</span>
